export default {
  lang(state) {
    // alert(`Getter state.lang:${state.lang}`);
    return state.lang;
  },

  default_lang(state) {
    return state.default_lang;
  },
};
